<template>
  <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-4 p-2">
      <div class="row Montos m-1 p-3">
        <div class="col-3 col-3 d-flex align-items-center justify-content-center">
          <img class="imagenMonto" src="../../../../../../public/icons/tipo-operacion.svg" />
        </div>
        <div class="col-9 d-flex flex-column justify-content-center ps-0">
          <p class="m-0">Tipo de operación</p>
          <p class="m-0">{{ operacion.tipoOperacion }}</p>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4 p-2">
      <div class="row Montos m-1 p-3">
        <div class="col-3 col-3 d-flex align-items-center justify-content-center">
          <img class="imagenMonto" src="../../../../../../public/icons/tipo-operacion.svg" />
        </div>
        <div class="col-9 d-flex flex-column justify-content-center ps-0">
          <p class="m-0">Uso del inmueble</p>
          <p class="m-0">{{ operacion.usoInmueble }}</p>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4 p-2">
      <div class="row Montos m-1 p-3">
        <div class="col-3 col-3 d-flex align-items-center justify-content-center">
          <img class="imagenMonto" src="../../../../../../public/icons/money.svg"/>
        </div>
        <div class="col-9 d-flex flex-column justify-content-center ps-0">
          <p class="m-0"> {{ $filters.MoneyFilter(operacion.totalMontoAdjudicado) }}</p>
          <p class="m-0">Total monto adjudicado</p>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4 p-2">
      <div class="row Montos m-1 p-3">
        <div class="col-3 col-3 d-flex align-items-center justify-content-center">
          <img class="imagenMonto" src="../../../../../../public/icons/money.svg"/>
        </div>
        <div class="col-9 d-flex flex-column justify-content-center ps-0">
          <p class="m-0"> {{ $filters.MoneyFilter(operacion.montoOperacion) }} </p>
          <p class="m-0">Monto de operación</p>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4 p-2">
      <div class="row Montos m-1 p-3">
        <div class="col-3 col-3 d-flex align-items-center justify-content-center">
          <img class="imagenMonto" src="../../../../../../public/icons/money.svg"/>
        </div>
        <div class="col-9 d-flex flex-column justify-content-center ps-0">
          <p class="m-0"> {{ $filters.MoneyFilter(operacion.valorGarantia) }}</p>
          <p class="m-0">Valor de la garantía</p>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4 p-2">
      <div class="row Montos m-1 p-3">
            <div class="col-3 col-3 d-flex align-items-center justify-content-center">
              <img class="imagenMonto" src="../../../../../../public/icons/money.svg"/>
            </div>
            <div class="col-9 d-flex flex-column justify-content-center ps-0">
              <p class="m-0"> {{ $filters.MoneyFilter(operacion.saldoInsoluto) }}</p>
              <p class="m-0">Saldo Insoluto</p>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "DetalleMontosOperacion",

  props: {
    operacion: {},
  },

  mounted() {
    //String(this.operacion.usoInmueble).length
  },
});
</script>

<style scoped>
.Montos {
  /* height: 100px; */
  height: 96%;
  border-radius: 15px;
  box-shadow: 5px 5px 15px 2px #b2b2b2;
}
.texto,
p,
span {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: #302d74;
}
.imagenMonto {
 /*  margin-top: 15px; */
  width: 35px;
  height: 35px;
}

.montoTextoA {
  margin-top: 15px;
  margin-left: 10px;
}

.montoTextoB {
  margin-top: -15px;
}
</style>
